// modules/navigation.js
import $ from 'jquery';

export function initNavigation() {

    // ---------------------------------------
    // Nav open/close
    // ---------------------------------------
    $('.navToggle').on('click', function () {
        const $navLinks = $('.nav__inner__links');
        const isOpen = $navLinks.toggleClass('--open').hasClass('--open');

        $('html').toggleClass('overflow-hidden', isOpen);

        // (Optional) if you really need to stop Lenis:
        // if (isOpen && window.lenis) lenis.stop();
        // else if (window.lenis) lenis.start();
    });

    $('.mobileCloseNavBtn').on('click', function () {
        $('.nav__inner__links').removeClass('--open');
        $('html').removeClass('overflow-hidden');

        // if (window.lenis) lenis.start(); // optional
    });

    // Open close search
    const $searchBar = $('.search-bar');
    const openClass = '--open';

    // Toggle on button click
    $('.searchToggle').on('click', function (e) {
        e.stopPropagation(); // prevent bubbling to document
        $searchBar.toggleClass(openClass);
    });

    // Prevent closing when clicking inside search bar
    $searchBar.on('click', function (e) {
        e.stopPropagation();
    });

    // Close when clicking outside
    $(document).on('click', function () {
        $searchBar.removeClass(openClass);
    });

    // ---------------------------------------
    // Allow native scroll inside nav scroll area
    // ---------------------------------------
    const navScrollable = document.querySelector('.nav__inner__links');
    if (navScrollable) {
        ['wheel', 'touchmove'].forEach(evt => {
            navScrollable.addEventListener(evt, e => e.stopPropagation(), { passive: false });
        });
    }

    // ---------------------------------------
    // Nav background toggle on scroll
    // ---------------------------------------
    const $nav = $('.nav');

    function checkNavPosition() {
        const scrollTop = $(window).scrollTop();

        if (scrollTop > $nav.outerHeight()) {
            $nav.addClass('--bg');
        } else {
            $nav.removeClass('--bg');
        }
    }

    // Run on load + scroll
    checkNavPosition();
    $(window).on('scroll', checkNavPosition);
}

// ---------------------------------------
// Navigation dropdowns
// ---------------------------------------
export function initNavigationDropdowns() {
    $('.has-link').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.dd').slideToggle(0);
    });
}

// ---------------------------------------
// Initialize all
// ---------------------------------------
initNavigationDropdowns();
initNavigation();
